module.exports = __webpack_public_path__ + "static/media/cmr_3.52618d1a.jpg";